define('controllers/mysetting/corpattation/valid-userinfocorp.ctrl',['app'], function (app) {
    app.controller('CorpattionValidCorp', ['$q', '$scope', '$state',  'auiDialog', 'OpenUp', 'UserInfo', 'formValidateService', '$rootScope','UserInfoPreload',
        function ($q, $scope, $state, auiDialog, OpenUp, UserInfo, formValidateService, $rootScope,UserInfoPreload) {
            var Model = $scope.Model = {
                userInfo:{},
                tipMsg:'',
                isShowScroll:false
            };
            $scope.contractUsis = systemParaConf.contractUsis;
            Model.notMatch = false;
            if($scope.isHarmony){
                Model.isShowScroll=true;
            }
            $rootScope.isFromAgc = ($rootScope.isFromAgc || UserInfoPreload.verifyRealState == 2);
            UserInfo.updateCache(init);
            function init(){
                $scope.contractCardUs = window.sysUrlCfg.documentHref.contractUs;
                UserInfo.promise().then(function(latestUserInfo) {
                    loginValidation.validateAfterLogin(latestUserInfo,function(){
                        Model.userInfo = latestUserInfo;
                        if(Model.userInfo.leftPayVerifyQuantity > 0){
                            Model.tipMsg = '您共有'+Model.userInfo.leftAmtVerifyQuantity+'次验证金额的机会，若'+Model.userInfo.leftAmtVerifyQuantity+'次都未能输入正确的打款金额，须重新认证。';
                        }else{
                            Model.tipMsg = '您共有'+Model.userInfo.leftAmtVerifyQuantity+'次验证金额的机会，若'+Model.userInfo.leftAmtVerifyQuantity+'次都未能输入正确的打款金额，只能'
                                +(UserInfoPreload.verifyRealState == 2?'联系客服处理。':'选择人工审核认证。') +'<span class="sandybrown">您将无法上架或更新您的敏感类应用。</span>' ;
                        }

                        if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
                            if (Model.userInfo.userType == 1) {
                                $state.go('mysetting.modUserInfoPer', {reload: true});
                                return;
                            } else if (Model.userInfo.userType == 2) {
                                if(Model.userInfo.verifyType == 3 && Model.userInfo.verifyRealState == 2){
                                    $state.go('mysetting.modUserInfoCorp', {},{reload: true});
                                    return;
                                }
                            }
                        } else {
                            $state.go('mysetting.memberDetail', {reload: true});
                            return;
                        }

                        var accountEmail = angular.copy(Model.userInfo.accountEmail);
                        var accountPhone = angular.copy(Model.userInfo.accountPhone);
                        // 获取模糊化帐号
                        if (Model.userInfo.accountEmail) {
                            Model.userInfo.fuzzyAccountEmail = AUI.BaseJSUtil.fuzzyEmail(accountEmail);
                        }
                        if (Model.userInfo.accountPhone) {
                            Model.userInfo.fuzzyAccountPhone = AUI.BaseJSUtil.fuzzyPhone(accountPhone);
                        }
                        OpenUp.getLatestPayVerifyBank({req:{}}).then(function (res) {
                            var payVerifyBankInfo = res.payVerifyBankInfo;
                            if(payVerifyBankInfo){
                                Model.bankInfoCN = angular.fromJson(payVerifyBankInfo);
                                Model.bankInfoCN.bankAccount = AUI.BaseJSUtil.fuzzyBankAccount(Model.bankInfoCN.bankAccount);
                            }
                        });
                    },true);
                });
            }
            ucdFlow();

            function ucdFlow(){
                new UCD.Workflow('#workflow', {
                    spacing:236,
                    steps: [
                        { title: '录入企业资料与银行账户信息', statu: 3 },
                        { title: '输入打款金额', statu: 2 },
                        { title: '完成认证', statu: 1 },
                    ]
                });
            }

            Model.payAmountup = function(){
                if(Model.notMatch){
                    Model.notMatch = false;
                }
            }

            Model.doSubmit = function(isValid){
                var defer = $q.defer();
                if(!isValid){
                    formValidateService.validateForm($scope.corpValidForm);
                    angular.element("[name='payAmount']").focus();
                    defer.reject();
                    return defer.promise;
                }

                OpenUp.verifyPayVerify({req:{payAmount:Model.payAmount}}).then(function (data) {
                    //验证金额成功
                    if(data.isMatch == 1){
                        if($scope.isHarmony){
                            auiDialog.warn("温馨提醒","恭喜您，完成企业开发者实名认证！请前往HarmonyOS管理中心了解更多信息。", function () {
                                if($scope.harmonyChannel == '8') {
                                    AUI.BaseJSUtil.redirectUrl(window.sysUrlCfg.user.harmonyMemberCenterUrl)
                                }else if($scope.harmonyChannel == '11'){
                                    AUI.BaseJSUtil.redirectUrl(window.sysUrlCfg.user.openHarmony)
                                }else if($scope.harmonyChannel == '12') {
                                    AUI.BaseJSUtil.redirectUrl(window.sysUrlCfg.user.harmonyOsOther)
                                }
                            });
                        }else{
                            $state.go('mysetting.validCorpResult', {
                                corpResult: 'validSuccess'
                            });
                        }
                    }else if(data.isMatch == 0){//验证金额失败
                        if(data.leftAmtVerifyQuantity > 0){//如果还存在金额验证次数
                            Model.userInfo.leftAmtVerifyQuantity = data.leftAmtVerifyQuantity;
                            angular.element("[name='payAmount']").focus();
                            Model.notMatch = true;
                            if(data.leftAmtVerifyQuantity == 1){
                                if(Model.userInfo.leftPayVerifyQuantity > 0){
                                    Model.tipMsg = '您仅剩1次验证金额的机会，若本次未能输入正确的打款金额，须重新认证。';
                                }else if(!$rootScope.isFromAgc){
                                    Model.tipMsg = '您仅剩1次验证金额的机会，若本次未能输入正确的打款金额，只能选择人工审核认证。'+'<span class="sandybrown">您将无法上架或更新您的敏感类应用。</span>';
                                }else{
                                    Model.tipMsg = '您仅剩1次验证金额的机会，若本次未能输入正确的打款金额，' + '请<a class=\"text-link\" target=\"_blank\" href=\"' + $scope.contractCardUs + '\">联系我们</a>';
                                }
                            }else{
                                if(Model.userInfo.leftPayVerifyQuantity > 0){
                                    Model.tipMsg = '您共有'+Model.userInfo.leftAmtVerifyQuantity+'次验证金额的机会，若'+Model.userInfo.leftAmtVerifyQuantity+'次都未能输入正确的打款金额，须重新认证。';
                                }else if(!$rootScope.isFromAgc){
                                    Model.tipMsg = '您共有'+Model.userInfo.leftAmtVerifyQuantity+'次验证金额的机会，若'+Model.userInfo.leftAmtVerifyQuantity+'次都未能输入正确的打款金额，只能选择人工审核认证。'+'<span style="color: sandybrown">您将无法上架或更新您的敏感类应用。</span>';
                                }else{
                                    Model.tipMsg = '您仅剩1次验证金额的机会，若本次未能输入正确的打款金额，' + '请<a class=\"text-link\" target=\"_blank\" href=\"' + $scope.contractCardUs + '\">联系我们</a>';
                                }
                            }
                            auiDialog.warn('提醒','输入错误，'+Model.tipMsg);
                        }else{
                            if(data.leftPayVerifyQuantity > 0){
                                $state.go('mysetting.validCorpResult', {
                                    corpResult: 'validFailhasChoice'
                                });
                            }else{
                                $state.go('mysetting.validCorpResult', {
                                    corpResult: 'validFailNoChoice'
                                });
                            }
                        }
                    }
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

        }]);
});

